import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchJobHistoryOperation({ jobHistoryOperationParams }) {
  try {
    yield put(Actions.setJobHistoryOperationLoaderStatus({ jobHistoryOperationLoader: true }));
    const { data } = yield call(api.get, {
      route: `job/history/${jobHistoryOperationParams.factoryId}/${jobHistoryOperationParams.equipmentId}/${jobHistoryOperationParams.toolNumber}/${jobHistoryOperationParams.pageNo}`,
    });
    const jobHistoryOperationData = data;
    yield put(Actions.setJobHistoryOperation({ jobHistoryOperationData }));
    yield put(Actions.setJobHistoryOperationLoaderStatus({ jobHistoryOperationLoader: false }));
  } catch (err) {
    yield put(Actions.setJobHistoryOperationLoaderStatus({ jobHistoryOperationLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* updateJobHistoryOperation({ jobHistoryOperationObj, jobHistoryOperationParams }) {
  try {
    yield put(Actions.setJobHistoryOperationLoaderStatus({ jobHistoryOperationLoader: true }));
    yield call(api.put, {
      route: 'job',
      data: jobHistoryOperationObj,
    });
    yield put(Actions.fetchJobHistoryOperation({ jobHistoryOperationParams }));
    notification('success', CONSTANT_VARIABLES.JOB_HISTORY_UPDATED, '');
  } catch (err) {
    yield put(Actions.setJobHistoryOperationLoaderStatus({ jobHistoryOperationLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_JOB_HISTORY_OPERATION, fetchJobHistoryOperation),
    takeLatest(ActionTypes.UPDATE_JOB_HISTORY_OPERATION, updateJobHistoryOperation),
  ]);
}
